import { gql } from '@apollo/client';
import * as directories from './directories';
import * as planOwners from './planOwners';
import * as users from './users';
import * as plans from './plans';
import * as map from './map';
import * as generationTasks from './generationTasks';
import * as siteVisit from './siteVisit';
import * as mapSession from './mapSession';
import * as contractors from './contractors';
import * as project from './project';
import * as order from './order';
import * as proposal from './proposal';

export const RESEND_SIGN_UP_TOKEN = gql`
  mutation ResendSignUpToken($email: String!) {
    resendSignUpToken(email: $email)
  }
`;

export const VERIFY_USER = gql`
  mutation VerifyUser($token: String!) {
    verifyUser(token: $token)
  }
`;
export const SIGN_UP = gql`
  mutation SignUp($email: String!, $password: String!, $name: String!, $roles: [String!]!) {
    signUp(email: $email, password: $password, name: $name, roles: $roles) {
      email
    }
  }
`;

export const LOG_IN_WITH_GOOGLE = gql`
  mutation LogInWithGoogle($code: String, $idToken: String) {
    LogInWithGoogle(code: $code, idToken: $idToken) {
      id
      name
      email
      roles
      createdAt
      contractor {
        id
        userId
        name
        phone
        email
        description
        availableArea {
          states
          counties
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const LOG_IN = gql`
  mutation LogIn($email: String!, $password: String!) {
    LogIn(email: $email, password: $password) {
      id
      name
      email
      roles
      createdAt
      contractor {
        id
        userId
        name
        phone
        email
        description
        availableArea {
          states
          counties
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($email: String!) {
    forgotPassword(email: $email)
  }
`;

export const CHANGE_PASSWORD_WITH_TOKEN = gql`
  mutation ChangePasswordWithToken($newPassword: String!, $token: String!) {
    ChangePasswordWithToken(newPassword: $newPassword, token: $token)
  }
`;

export const LOG_OUT = gql`
  mutation LogOut {
    LogOut
  }
`;

export const VERIFY_LOGGED_IN = gql`
  mutation CheckIfLoggedIn {
    CheckIfLoggedIn {
      id
      isVerified
      name
      email
      roles
      createdAt
      contractor {
        id
        userId
        name
        phone
        email
        description
        availableArea {
          states
          counties
        }
        createdAt
        updatedAt
      }
    }
  }
`;

export const TEMPLATE_CREATE = gql`
  mutation TemplateCreate(
    $typeformId: String!
    $title: String!
    $link: String!
    $specifications: JSON
  ) {
    templateCreate(
      typeformId: $typeformId
      title: $title
      link: $link
      specifications: $specifications
    ) {
      id
      typeformId
      title
      link
      specifications
    }
  }
`;

export const TEMPLATE_UPDATE = gql`
  mutation TemplateUpdate(
    $id: ID!
    $typeformId: String!
    $title: String!
    $link: String!
    $specifications: JSON
  ) {
    templateUpdate(
      id: $id
      typeformId: $typeformId
      title: $title
      link: $link
      specifications: $specifications
    ) {
      id
      typeformId
      title
      link
      specifications
    }
  }
`;

export {
  directories,
  planOwners,
  users,
  plans,
  map,
  generationTasks,
  siteVisit,
  mapSession,
  contractors,
  project,
  order,
  proposal,
};
